import { render, staticRenderFns } from "./ListAutomatedResponse.vue?vue&type=template&id=35a4ef00"
import script from "./ListAutomatedResponse.vue?vue&type=script&lang=js"
export * from "./ListAutomatedResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListAutomatedResponse.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a4ef00')) {
      api.createRecord('35a4ef00', component.options)
    } else {
      api.reload('35a4ef00', component.options)
    }
    module.hot.accept("./ListAutomatedResponse.vue?vue&type=template&id=35a4ef00", function () {
      api.rerender('35a4ef00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/ListAutomatedResponse.vue"
export default component.exports